export class Department {
	public id			: number;
	public name			: string;
	public description	: string;
	public slug			: string;
}
